import React from 'react';
import { ClinicInfoPanel } from '../info/clinicInfoParts';

const recallMediums = [
    { value: 'EMAIL', label: 'Email', icon: 'bi-envelope-fill' },
    { value: 'SMS', label: 'SMS', icon: 'bi-chat-text-fill' },
    { value: 'CALL', label: 'Phone Call', icon: 'bi-telephone-fill' },
];

const RecallMediumDisplay = ({ mediumValue }) => {
    const currentMedium = recallMediums.find((m) => m.value === mediumValue) || recallMediums[0];

    return (
        <div className="clinic-settings-sequence-detail">
            <i className={`bi ${currentMedium.icon} clinic-settings-sequence-detail__icon`}></i>
            <span className="clinic-settings-sequence-detail__label">Medium</span>
            <span className="clinic-settings-sequence-detail__value">{currentMedium.label}</span>
        </div>
    );
};

const RecallSequenceCard = ({ title, subtitle, isEnabled, medium, waitPeriod }) => (
    <div className="clinic-settings-sequence-card">
        <div className="clinic-settings-sequence-card__header">
            <div className="clinic-settings-sequence-card__title-wrap">
                <span className="clinic-settings-sequence-card__icon">
                    <i className="bi bi-arrow-repeat"></i>
                </span>
                <div>
                    <h6 className="clinic-settings-sequence-card__title">{title}</h6>
                    <p className="clinic-settings-sequence-card__subtitle">{subtitle}</p>
                </div>
            </div>
            <span className={`clinic-settings-status-pill ${isEnabled ? 'is-open' : 'is-closed'}`}>
                <i className={`bi ${isEnabled ? 'bi-check-circle-fill' : 'bi-x-circle-fill'}`}></i>
                {isEnabled ? 'Enabled' : 'Disabled'}
            </span>
        </div>
        <div className="clinic-settings-sequence-card__body">
            <RecallMediumDisplay mediumValue={medium} />
            <div className="clinic-settings-sequence-detail">
                <i className="bi bi-calendar-week clinic-settings-sequence-detail__icon"></i>
                <span className="clinic-settings-sequence-detail__label">Wait Period</span>
                <span className="clinic-settings-sequence-detail__value">{waitPeriod ?? '—'} days</span>
            </div>
        </div>
    </div>
);

const RecallSettings = ({ settings }) => {
    if (!settings) {
        return null;
    }

    const limits = [
        { label: 'Email', icon: 'bi-envelope', value: settings.emailLimitPerDay },
        { label: 'SMS', icon: 'bi-chat-text', value: settings.smsLimitPerDay },
        { label: 'Call', icon: 'bi-telephone', value: settings.callLimitPerDay },
    ];

    const sequences = [
        {
            title: 'Second Recall',
            subtitle: 'Follow-up after the first recall',
            isEnabled: settings.isSecondRecall,
            medium: settings.secondRecallMedium,
            waitPeriod: settings.secondRecallWaitPeriod,
        },
        {
            title: 'Third Recall',
            subtitle: 'Follow-up after the second recall',
            isEnabled: settings.isThirdRecall,
            medium: settings.thirdRecallMedium,
            waitPeriod: settings.thirdRecallWaitPeriod,
        },
        {
            title: 'Fourth Recall',
            subtitle: 'Follow-up after the third recall',
            isEnabled: settings.isFourthRecall,
            medium: settings.fourthRecallMedium,
            waitPeriod: settings.fourthRecallWaitPeriod,
        },
    ];

    return (
        <>
            <ClinicInfoPanel title="Daily Recall Limits" icon="bi-bell">
                <div className="clinic-settings-recall-limits">
                    {limits.map((limit) => (
                        <div key={limit.label} className="clinic-settings-recall-limit">
                            <span className="clinic-settings-recall-limit__icon">
                                <i className={`bi ${limit.icon}`}></i>
                            </span>
                            <div>
                                <span className="clinic-settings-recall-limit__label">{limit.label}</span>
                                <span className="clinic-settings-recall-limit__value">
                                    {(limit.value ?? 0).toLocaleString()}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </ClinicInfoPanel>

            <ClinicInfoPanel title="Recall Sequence" icon="bi-diagram-3">
                <div className="clinic-settings-sequence-list">
                    {sequences.map((sequence) => (
                        <RecallSequenceCard key={sequence.title} {...sequence} />
                    ))}
                </div>
            </ClinicInfoPanel>
        </>
    );
};

export default RecallSettings;
